module.exports = __webpack_public_path__ + "static/media/2.68a5f0b9.webp";